import moment from 'moment'

// Form helpers

// Expects a Moment object for each date
export const calcNightsMoment = (start, end) => end.diff(start, 'days')

export const calcNights = (start, end) => {
  let date1_ms = start.getTime()
  let date2_ms = end.getTime()
  let difference_ms = date2_ms - date1_ms
  let nights = Math.round(difference_ms / (1000 * 60 * 60 * 24))
  return nights
}

// Calc min departure date from nights
export const setMinDepartureDate = (date, nights) => {
  let minDeparture = new Date(date)
  minDeparture.setDate(minDeparture.getDate() + parseInt(nights))
  return minDeparture
}

// Calc min departure date by nights
// Date: Momemt object
// Nights: (number)
export const setMinDepartureDateMoment = (date, nights) => moment(date).add(nights, "days")